import { Subject, BehaviorSubject } from "rxjs";

export type TRANSFORMER_ACTIONS = TRANSFORMER_ACTION | string; // Allow subclasses to extend with more specific actions
export enum TRANSFORMER_ACTION {
  SAVE = "SAVE",
  CANCEL = "CANCEL",
}

export enum TRANSFORMER_STATE {
  EDITING,
  PENDING,
  DONE,
  ERROR,
}

export abstract class AbstractTransformerService {
  protected _state$ = new BehaviorSubject<TRANSFORMER_STATE>(TRANSFORMER_STATE.EDITING);
  protected _action$ = new Subject<TRANSFORMER_ACTIONS>();

  public get state$() {
    return this._state$.asObservable();
  }
  public get state() {
    return this._state$.getValue();
  }
  public set state(s: TRANSFORMER_STATE) {
    this._state$.next(s);
  }

  public get action$() {
    return this._action$.asObservable();
  }

  public doAction(action: TRANSFORMER_ACTIONS) {
    this._action$.next(action);
  }

  reset() {
    this.state = TRANSFORMER_STATE.EDITING;
  }
}
